import React, { useCallback } from "react";

import { DraggableWrapper, HubCircularProgress } from "../../components";

import { StyledContainer } from "./styles";

const KanbanBoard = ({
  columns = [],
  CardComponent,
  onStageChange,
  isLoading = false,
  StartComponent,
}) => {
  const handleChange = useCallback(
    (_newState, dragInfo) => {
      if (!dragInfo) return;
      const { draggableId, toId } = dragInfo;
      if (!draggableId || !toId) return;
      onStageChange?.({
        id: Number(draggableId),
        stage: Number(toId),
      });
    },
    [onStageChange],
  );

  if (isLoading) return <HubCircularProgress />;

  return (
    <StyledContainer>
      <DraggableWrapper
        elements={columns}
        Component={CardComponent}
        onChange={handleChange}
        StartComponent={StartComponent}
      />
    </StyledContainer>
  );
};

export default KanbanBoard;
